<div class="journey" testId="tenant-contact-journey-container">
  <div class="toolbar" [class.compact]="roomOnly" testId="tenant-contact-journey-toolbar">
    <div *ngIf="!roomOnly"><small>CONTACT JOURNEY</small><h3>客戶服務歷程</h3></div>
    <nz-range-picker
      [(ngModel)]="range"
      (ngModelChange)="onRangeChange()"
      nzFormat="yyyy-MM-dd"
      testId="tenant-contact-journey-range-picker"
    />
  </div>
  <div class="grid" [class.rooms-only]="roomOnly" [class.session-detail]="!roomOnly && !!initialRoom">
    <section class="panel room-panel" *ngIf="roomOnly || !initialRoom" testId="tenant-contact-journey-room-panel">
      <header
        >服務號 <b>{{ roomTotal }}</b></header
      >
      <div class="room-table-head" *ngIf="roomOnly">
        <span>服務號名稱</span><span>首次進線時間</span><span>最近進線時間</span><span>進線次數</span><span></span>
      </div>
      <nz-spin [nzSpinning]="loadingRooms" testId="tenant-contact-journey-rooms-spin">
        <button
          class="list-item"
          [class.room-row]="roomOnly"
          *ngFor="let room of rooms"
          [class.active]="selectedRoom?.roomId === room.roomId"
          (click)="selectRoom(room)"
          [testId]="'tenant-contact-journey-room-item-' + room.roomId"
        >
          <ng-container *ngIf="roomOnly; else compactRoom">
            <strong>{{ room.serviceNumberName || '-' }}</strong>
            <span class="first-time">{{ formatTime(room.firstSessionStartTime) }}</span>
            <span class="latest-time">{{ formatTime(room.latestSessionStartTime) }}</span>
            <span class="inbound-count">{{ room.inboundCount || 0 }}</span>
          </ng-container>
          <ng-template #compactRoom>
            <span>
              <strong>{{ room.serviceNumberName || '-' }}</strong>
              <small>{{ room.inboundCount || 0 }} 次進線</small>
            </span>
          </ng-template>
          <i nz-icon nzType="right"></i>
        </button>
        <nz-empty *ngIf="!rooms.length" nzNotFoundContent="尚無進線服務號" testId="tenant-contact-journey-rooms-empty" />
      </nz-spin>
      <nz-pagination
        *ngIf="roomTotal > roomPageSize"
        nzSimple
        [nzPageIndex]="roomPage"
        [nzPageSize]="roomPageSize"
        [nzTotal]="roomTotal"
        (nzPageIndexChange)="roomPage = $event; loadRooms()"
        testId="tenant-contact-journey-rooms-pagination"
      />
    </section>
    <section class="panel" *ngIf="!roomOnly" testId="tenant-contact-journey-session-panel">
      <header
        >Session <b>{{ sessionTotal }}</b></header
      >
      <nz-spin [nzSpinning]="loadingSessions" testId="tenant-contact-journey-sessions-spin">
        <div class="session-list" testId="tenant-contact-journey-session-list">
          <button
            class="session"
            *ngFor="let item of sessions"
            [class.active]="selectedSession?.sessionId === item.sessionId"
            (click)="selectSession(item)"
            [testId]="'tenant-contact-journey-session-item-' + item.sessionId"
          >
            <div>
              <strong>{{ formatTime(item.sessionStartTime) }}</strong>
              <nz-tag>{{ getSessionStatusText(item.status) }}</nz-tag>
            </div>
            <small>
              <span *ngIf="item.hasRobot">機器人</span><span *ngIf="item.hasTransferredToAgent">已轉人工</span>
              <span *ngIf="item.hasSatisfaction">★ {{ item.satisfactionScore }}</span>
            </small>
            <p *ngIf="item.inboundReasonName">{{ item.inboundReasonName }}</p>
          </button>
          <nz-empty *ngIf="!sessions.length" nzNotFoundContent="此服務號尚無 Session" testId="tenant-contact-journey-sessions-empty" />
        </div>
      </nz-spin>
      <nz-pagination
        *ngIf="sessionTotal > sessionPageSize"
        nzSimple
        [nzPageIndex]="sessionPage"
        [nzPageSize]="sessionPageSize"
        [nzTotal]="sessionTotal"
        (nzPageIndexChange)="sessionPage = $event; selectedRoom && loadSessions(selectedRoom)"
        testId="tenant-contact-journey-sessions-pagination"
      />
    </section>
    <section class="panel chat" *ngIf="!roomOnly" testId="tenant-contact-journey-chat-panel">
      <header
        >對話預覽 <b>{{ getSessionStatusText(selectedSession?.status) }}</b></header
      >
      <div class="meta" *ngIf="selectedSession">
        {{ formatTime(selectedSession.sessionStartTime) }}
        <span *ngIf="selectedSession.inboundReasonName">· {{ selectedSession.inboundReasonName }}</span>
      </div>
      <nz-spin [nzSpinning]="loadingMessages" testId="tenant-contact-journey-messages-spin">
        <div
          #messageContainer
          class="messages"
          (scroll)="onMessageScroll($event)"
          *ngIf="messages.length"
          testId="tenant-contact-journey-messages"
        >
          <article
            *ngFor="let item of messages; let i = index"
            [ngClass]="getMessageRole(item)"
            [attr.data-testid]="'tenant-contact-journey-message-' + i"
          >
            <ng-container *ngIf="getMessageRole(item) === 'system'; else chatMessage">
              <div class="system-event">
                <span class="event-source">系統</span>
                <strong>{{ getMessagePreview(item.content) }}</strong>
                <details class="raw-content" *ngIf="isStructuredMessage(item.content)">
                  <summary aria-label="查看原始內容" nz-tooltip nzTooltipTitle="查看原始內容"><i nz-icon nzType="code"></i></summary>
                  <pre>{{ item.content }}</pre>
                </details>
                <time>{{ formatTime(item.sendTime) }} · #{{ item.sequence }}</time>
              </div>
            </ng-container>
            <ng-template #chatMessage>
              <div class="message-stack">
                <small class="message-sender">{{ getMessageRoleLabel(item) }} · {{ item.senderName || '未知發送者' }}</small>
                <div class="message-bubble" [class.has-raw]="isStructuredMessage(item.content)">
                  <p>{{ getMessagePreview(item.content) }}</p>
                  <details class="raw-content" *ngIf="isStructuredMessage(item.content)">
                    <summary aria-label="查看原始內容" nz-tooltip nzTooltipTitle="查看原始內容"><i nz-icon nzType="code"></i></summary>
                    <pre>{{ item.content }}</pre>
                  </details>
                </div>
                <time class="message-footer">{{ formatTime(item.sendTime) }} · #{{ item.sequence }}</time>
              </div>
            </ng-template>
          </article>
        </div>
        <nz-empty *ngIf="!messages.length" nzNotFoundContent="選擇 Session 查看對話" testId="tenant-contact-journey-chat-empty" />
      </nz-spin>
    </section>
  </div>
</div>
